<!-- 选课中心 -->
<template>
    <div class="el-courseSelection">
        <el-row class="page_content">
            <h1 class="head_title">选课中心</h1>
            <el-table
                :data="tableData"
                border
                style="width: 100%">
                <el-table-column
                    prop="courseTypeConcat"
                    header-align="center"
                    align="center"
                    label="课程类别">
                </el-table-column>
                <el-table-column
                    prop="courseName"
                    header-align="center"
                    align="center"
                    label="课程名称">
                </el-table-column>
                <el-table-column
                prop="teacherName"
                header-align="center"
                align="center"
                label="教师名称">
                </el-table-column>
                <el-table-column
                prop="courseSource"
                header-align="center"
                align="center"
                label="学分"
                width="180">
                </el-table-column>
                <el-table-column
                    prop="isOnline"
                    header-align="center"
                    align="center"
                    label="是否网学"
                    width="180">
                    <template slot-scope="scope">
                        <span :class="scope.row.isOnline === '1'?'wd':''">{{scope.row.isOnline === "1"?'是':scope.row.isOnline === "2"?"否":"-"}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                prop="address"
                header-align="center"
                align="center"
                label="课程数量"
                width="180">
                </el-table-column>
                <el-table-column
                prop="address"
                header-align="center"
                align="center"
                label="课余量"
                width="180">
                </el-table-column>
                <el-table-column
                prop="address"
                header-align="center"
                align="center"
                label="选课"
                width="100">
                <template slot-scope="scope">
                    <el-checkbox :value="scope.row.state == 1"  @change="selectCourse(scope.$index)"></el-checkbox>
                </template>
                </el-table-column>
            </el-table>
            <h1 class="head_title" style="margin-top:20px;">
              选课结果
              <el-button plain v-if="false" @click="electiveCourse" style="float: right;margin-top:-7px;" :loading="submitBut">确认选课</el-button>
            </h1>
            <el-table
                :data="multipleSelection"
                border
                style="width: 100%">
                <el-table-column
                    prop="courseName"
                    header-align="center"
                    align="center"
                    label="课程名称">
                </el-table-column>
                <el-table-column
                prop="teacherName"
                header-align="center"
                align="center"
                label="教师名称">
                </el-table-column>
                <el-table-column
                prop="courseSource"
                header-align="center"
                align="center"
                label="学分"
                width="180">
                </el-table-column>
                <el-table-column
                    prop="isOnline"
                    header-align="center"
                    align="center"
                    label="是否网学"
                    width="180">
                    <template slot-scope="scope">
                        <span :class="scope.row.isOnline === '1'?'wd':''">{{scope.row.isOnline === "1"?'是':scope.row.isOnline === "2"?"否":"-"}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                prop="address"
                header-align="center"
                align="center"
                label="退课"
                width="180">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="retreatCourse(scope.$index)" size="mini">退课</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
    </div>
</template>
<script>
export default {
  name: "CourseSelection",
  data() {
    return {
      tableData: [],
      multipleSelection:[],
      submitBut:false
    };
  },
  created() {
    this.getElectiveCourse();
    this.getSelectedElectiveCourse();
  },
  methods: {
    selectCourse(index){ //取消选中
        if(this.tableData[index].state == 1){
            this.tableData[index].state = 2;
            this.tableData = Object.assign([],this.tableData);
            this.delCourse(index);
        }else{ //选中
            this.tableData[index].state = 1;
            this.tableData = Object.assign([],this.tableData);
            this.onSelectCourse(index);
        }
    },
    retreatCourse(index){
      this.delCourse(index);
    },
    getElectiveCourse(){ //获取选课列表List(全部)
      this.$store.dispatch("user/getElectiveCourse").then((ret) => {
        if (ret.code === 0 || ret.code === '0') {
          this.tableData = ret.data;
        } else {
          this.$message({
             message: ret.msg,
             type: 'warning'
          });
        }
      })
    },
    getSelectedElectiveCourse(){ //获取选课列表List(已选)
      this.$store.dispatch("user/getSelectedElectiveCourse").then((ret) => {
        if (ret.code === 0 || ret.code === '0') {
          this.multipleSelection = ret.data;
          if(ret.data != null){
            let tePlanCourseIds = ",";
            ret.data.forEach((element,i) => {
              tePlanCourseIds += element.tePlanCourseId + ",";
            });
            this.tableData.forEach((element,i) => {
              if(tePlanCourseIds.indexOf(","+element.tePlanCourseId+",") >= 0){
                this.tableData[i].state = 1;
              }
            });
            this.tableData = Object.assign([],this.tableData);
          }
        } else {
          this.$message({
             message: ret.msg,
             type: 'warning'
          });
        }
      })
    },
    electiveCourse(){ //提交选课信息
      this.submitBut = true;
      this.$confirm('是否确定选课，确认后将无法修改?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch("user/electiveCourse").then((ret) => {
          this.submitBut = false;
          this.$message({
             message: ret.msg,
             type: ret.code == 0?"success":'warning'
          });
        })
      }).catch(() => {
        this.submitBut = false;
      });
    },
    onSelectCourse(index){ //选课
      this.$store.dispatch("user/electiveCourse",{tePlanCourseId:this.tableData[index].tePlanCourseId}).then((ret) => {
        if(ret.code == 0){
          this.getSelectedElectiveCourse();
        }
        this.$message({
           message: ret.msg,
           type: ret.code == 0?"success":'warning'
        });
      })
    },
    delCourse(index){ //退课
      this.$store.dispatch("user/delElectiveCourse",{tePlanCourseId:this.multipleSelection[index].tePlanCourseId}).then((ret) => {
        if(ret.code == 0){
          this.getSelectedElectiveCourse();
        }
        this.$message({
           message: ret.msg,
           type: ret.code == 0?"success":'warning'
        });
      })
    }
  }
};
</script>
<style  lang="less">
  @import '../styles/base.less';
  .el-courseSelection{
    .wd{
        color: @red;
    }
    .el-dialog__body{
        border-top:1px solid #ebeef5;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/CourseSelection.vue